
import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const AgentsService = {

    getStatuses: (account_id) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/get-status-table/${account_id}`);
    },
    setMessagesRestriccion: (messages_restriccion: 0|1,  status_of_table_id: number ) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/status-of-table-change-message-restriccion`, { messages_restriccion, status_of_table_id });
    },
    addState: (data) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/addStatusTable`, data);
    },
    deleteState: (status_of_table_id: string) => {
        return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}accounts/delete-status-of-table`, { data: { status_of_table_id } });
    },
    
}